import * as React from "react";
import { theme } from "../theme.css";
import * as styles from "./badge.css";

interface BadgeProps {
  topText?: string;
  bottomText?: string;
  background?: string;        // circle + default text colour
  borderColor?: string;
  textColor?: string;         // new – optional override for first-render text
  className?: string;
  children: React.ReactNode;
}

export default function Badge({
  topText,
  bottomText,
  children,
  className = "",
  background = theme.colors.white,
  textColor = "#000",          // sensible default
  borderColor,
}: BadgeProps) {
  return (
    <div
      /* 1️⃣  inject the colours as CSS custom properties            */
      style={{
        "--badge-bg": background,
        "--badge-fg": textColor,
        "--badge-border": borderColor ?? "transparent",
      } as React.CSSProperties}
      className={`${styles.container} ${className}`}
    >
      <span className={styles.childrenContainer}>{children}</span>

      <svg
        className={styles.svg}
        viewBox="0 0 132 132"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          id="badge-top"
          d="M15 69C15 55.7392 20.3732 43.0215 29.9376 33.6447C39.5019 24.2678 52.474 19 66 19C79.526 19 92.4981 24.2678 102.062 33.6447C111.627 43.0215 117 55.7392 117 69"
        />
        <path
          id="badge-bottom"
          d="M9 65C9 80.3826 15.0054 95.1351 25.6949 106.012C36.3844 116.89 50.8826 123 66 123C81.1174 123 95.6156 116.89 106.305 106.012C116.995 95.1351 123 80.3826 123 65"
        />

        {/*  text inherits currentColor, so it flips too  */}
        <text fill="currentColor">
          <textPath
            className={styles.topText}
            href="#badge-top"
            startOffset="50%"
            textAnchor="middle"
          >
            {topText}
          </textPath>
        </text>
        <text fill="currentColor">
          <textPath
            className={styles.bottomText}
            href="#badge-bottom"
            startOffset="50%"
            textAnchor="middle"
          >
            {bottomText}
          </textPath>
        </text>
      </svg>
    </div>
  );
}
